export default __webpack_public_path__ + "media/images/portfolio/gallery-05-480x290-4eaba6b274f5054b9bb5f91079897ebb.jpg";